import ApiClient from '../../../helpers/apiClient';
import { startSubmit } from 'redux-form';

export const FETCH_SMS_REQUEST = 'FETCH_SMS_REQUEST';
export const FETCH_SMS_SUCCESS = 'FETCH_SMS_SUCCESS';
export const FETCH_SMS_ERROR = 'FETCH_SMS_ERROR';

export const IMPORT_SMS_REQUEST = 'IMPORT_SMS_REQUEST';
export const IMPORT_SMS_SUCCESS = 'IMPORT_SMS_SUCCESS';
export const IMPORT_SMS_ERROR = 'IMPORT_SMS_ERROR';

export const FETCH_SMS_HISTORY_REQUEST = 'FETCH_SMS_HISTORY_REQUEST';
export const FETCH_SMS_HISTORY_SUCCESS = 'FETCH_SMS_HISTORY_SUCCESS';
export const FETCH_SMS_HISTORY_ERROR = 'FETCH_SMS_HISTORY_ERROR';

export const fetchSMS = data => dispatch => {
  return Promise.resolve().then(() =>
    dispatch({
      types: [FETCH_SMS_REQUEST, FETCH_SMS_SUCCESS, FETCH_SMS_ERROR],
      callAPI: () => ApiClient.post('network/SparkNotificationLog/Search', data),
      payload: { data },
    }),
  );
};

export const importSMS = formFileData => dispatch => {
  return Promise.resolve().then(() =>
      dispatch({
          types: [
            IMPORT_SMS_REQUEST,
            IMPORT_SMS_SUCCESS,
            IMPORT_SMS_ERROR,
          ],
          callAPI: () => ApiClient.post(`scheduler/Notification/SparkPushNotification `, formFileData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          }),
          payload: { },
      }),
  );
};

export const fetchSMSHistories = data => dispatch => {
  return Promise.resolve().then(() =>
    dispatch({
      types: [
        FETCH_SMS_HISTORY_REQUEST,
        FETCH_SMS_HISTORY_SUCCESS,
        FETCH_SMS_HISTORY_ERROR,
      ],
      callAPI: () => ApiClient.post(`network/SparkNotificationLog/SearchImportHistory`, data),
      payload: { data },
    }),
  );
};

const initialState = {
  payload: {},
  data: {},
  response: {},
  error: {},
  errorMessage: '',
  successMessage: '',
};

export default function reducer(state = initialState, action) {
  const { payload, response, error, successMessage, errorMessage } = action;
  switch (action.type) {
    case FETCH_SMS_REQUEST:
    case IMPORT_SMS_REQUEST:
    case FETCH_SMS_HISTORY_REQUEST:
      return {
        ...state,
        payload,
        response: {},
        error: {},
        successMessage: '',
        errorMessage: '',
      };

    case FETCH_SMS_SUCCESS:
    case FETCH_SMS_HISTORY_SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          items: response.data.data.items,
          pages: response.data.data.pageCount,
        },
        response,
        successMessage,
      };

    case IMPORT_SMS_SUCCESS:
      return {
        ...state,
        response,
        successMessage,
      };

    case FETCH_SMS_ERROR:
    case IMPORT_SMS_ERROR:
    case FETCH_SMS_HISTORY_ERROR:
      return {
        ...state,
        payload,
        error,
        errorMessage,
      };
    default:
      return state;
  }
}
